import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  id: "create-booking-shipment-v3-retail",
  ref: "create-booking-shipment-v3-client",
  class: "flex flex-col h-full relative"
}
const _hoisted_2 = { class: "px-10 py-4 flex flex-row justify-between gap-4 items-center border-b border-gray-lp-1400" }
const _hoisted_3 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "w-6 h-6",
  src: _imports_0,
  alt: "back"
}, null, -1)
const _hoisted_5 = { class: "text-black-lp-200 font-semibold text-xl" }
const _hoisted_6 = {
  tabindex: "-1",
  ref: "create-booking-retail-form-container",
  class: "bg-gray-lp-1000 flex-grow-1 h-full px-10 py-2.5 overflow-auto w-full"
}
const _hoisted_7 = {
  class: "overflow-auto",
  style: {"max-height":"89%"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { id: "create-booking-retail-form" }, null, -1)
const _hoisted_9 = { class: "flex flex-row w-full gap-2 mb-2" }
const _hoisted_10 = { class: "flex flex-row gap-2 mb-2" }
const _hoisted_11 = {
  key: 1,
  "data-testid": "booking-doc-international-section"
}
const _hoisted_12 = {
  key: 2,
  class: "py-1"
}
const _hoisted_13 = { class: "flex flex-row mt-2 gap-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListHistorySuccessBooking = _resolveComponent("ListHistorySuccessBooking")!
  const _component_FilterClient = _resolveComponent("FilterClient")!
  const _component_STTManualReference = _resolveComponent("STTManualReference")!
  const _component_DetailSender = _resolveComponent("DetailSender")!
  const _component_BookingSdnBanner = _resolveComponent("BookingSdnBanner")!
  const _component_DetailReceiver = _resolveComponent("DetailReceiver")!
  const _component_Commodity = _resolveComponent("Commodity")!
  const _component_DeliveryService = _resolveComponent("DeliveryService")!
  const _component_DetailKoli = _resolveComponent("DetailKoli")!
  const _component_InsuranceBanner = _resolveComponent("InsuranceBanner")!
  const _component_DocInternational = _resolveComponent("DocInternational")!
  const _component_DeliveryType = _resolveComponent("DeliveryType")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_DialogPayment = _resolveComponent("DialogPayment")!
  const _component_ModalSuccessBooking = _resolveComponent("ModalSuccessBooking")!
  const _component_ModalFailedBooking = _resolveComponent("ModalFailedBooking")!
  const _component_ModalPreviewInvoice = _resolveComponent("ModalPreviewInvoice")!
  const _component_ModalSuccessReceipt = _resolveComponent("ModalSuccessReceipt")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("section", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_4
          ]),
          _createVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("Booking baru")), 1)
        ]),
        _createVNode(_component_ListHistorySuccessBooking)
      ]),
      _createVNode("section", _hoisted_6, [
        _createVNode("section", _hoisted_7, [
          _hoisted_8,
          (_ctx.isAccountPosOrInternal)
            ? (_openBlock(), _createBlock(_component_FilterClient, {
                key: 0,
                ref: "filter-client",
                modelValue: _ctx.form.clientName,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.clientName = $event)),
                  _ctx.handleResetFormShipmentId
                ],
                sender: _ctx.form.sender,
                "onUpdate:sender": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.sender = $event)),
                phoneSender: _ctx.form.phoneSender,
                "onUpdate:phoneSender": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.phoneSender = $event)),
                phoneCodeSender: _ctx.form.phoneCodeSender,
                "onUpdate:phoneCodeSender": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.phoneCodeSender = $event)),
                addressSender: _ctx.form.addressSender,
                "onUpdate:addressSender": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.addressSender = $event)),
                currentIndex: _ctx.currentIndex,
                "onUpdate:currentIndex": _cache[7] || (_cache[7] = ($event: any) => (_ctx.currentIndex = $event)),
                error: _ctx.error,
                "onUpdate:error": _cache[8] || (_cache[8] = ($event: any) => (_ctx.error = $event)),
                clientIndex: 0.5,
                onClient: _ctx.onSelectClient,
                updateClientIdFromShipment: _ctx.clientIdFromShipment
              }, null, 8, ["modelValue", "sender", "phoneSender", "phoneCodeSender", "addressSender", "currentIndex", "error", "clientIndex", "onClient", "onUpdate:modelValue", "updateClientIdFromShipment"]))
            : _createCommentVNode("", true),
          _createVNode(_component_STTManualReference, {
            ref: "stt-manual-reference",
            id: "create-booking-retail-stt-manual",
            class: "mb-2",
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form = $event)),
            currentIndex: _ctx.currentIndex,
            "onUpdate:currentIndex": _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentIndex = $event)),
            error: _ctx.error,
            "onUpdate:error": _cache[11] || (_cache[11] = ($event: any) => (_ctx.error = $event)),
            errorSttReference: _ctx.isErrorSttReference,
            "onUpdate:errorSttReference": _cache[12] || (_cache[12] = ($event: any) => (_ctx.isErrorSttReference = $event)),
            errorSttManual: _ctx.isErrorSttManual,
            "onUpdate:errorSttManual": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isErrorSttManual = $event)),
            errorShipmentId: _ctx.isErrorShipmentId,
            "onUpdate:errorShipmentId": _cache[14] || (_cache[14] = ($event: any) => (_ctx.isErrorShipmentId = $event)),
            loadingValidateShipmentId: _ctx.loadingValidateShipmentId,
            "onUpdate:loadingValidateShipmentId": _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadingValidateShipmentId = $event)),
            isDO: _ctx.isDO,
            sttNoRefExternalIndex: 1,
            formType: "client",
            onHandleGetClientData: _ctx.handleGetClientDataFromShipment
          }, null, 8, ["modelValue", "currentIndex", "error", "errorSttReference", "errorSttManual", "errorShipmentId", "loadingValidateShipmentId", "isDO", "onHandleGetClientData"]),
          _createVNode(_component_DetailSender, {
            ref: "detail-sender",
            class: "mb-2",
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form = $event)),
            currentIndex: _ctx.currentIndex,
            "onUpdate:currentIndex": _cache[17] || (_cache[17] = ($event: any) => (_ctx.currentIndex = $event)),
            errors: _ctx.error,
            "onUpdate:errors": _cache[18] || (_cache[18] = ($event: any) => (_ctx.error = $event)),
            senderNameIndex: 2,
            senderPhoneIndex: 3,
            senderAddressIndex: 4,
            saveSenderIndex: 5,
            formType: "client"
          }, null, 8, ["modelValue", "currentIndex", "errors"]),
          _createVNode(_component_DetailReceiver, {
            ref: "detail-receiver",
            id: "booking-receiver-section",
            class: "mb-2",
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form = $event)),
            currentIndex: _ctx.currentIndex,
            "onUpdate:currentIndex": _cache[20] || (_cache[20] = ($event: any) => (_ctx.currentIndex = $event)),
            errors: _ctx.error,
            "onUpdate:errors": _cache[21] || (_cache[21] = ($event: any) => (_ctx.error = $event)),
            listKGs: _ctx.form.pieces,
            receiverNameIndex: 6,
            receiverPhoneIndex: 7,
            receiverAddressIndex: 8,
            receiverDestinationCityIndex: 9,
            receiverPostalCodeIndex: 10,
            saveReceiverIndex: 11,
            onSelectDistrict: _ctx.onResetPaymentMethod,
            isErrorEmbargo: _ctx.isErrorEmbargoDestination,
            formType: "client",
            isRebookingFlow: _ctx.isRebookingFlow,
            isErrorRouteNotFound: _ctx.errorRouteNotFound,
            "onUpdate:isErrorRouteNotFound": _cache[22] || (_cache[22] = ($event: any) => (_ctx.errorRouteNotFound = $event))
          }, {
            "destination-info": _withCtx(() => [
              _createVNode(_component_BookingSdnBanner, {
                variant: "v3",
                originDistrict: _ctx.districtDetail,
                destinationDistrict: _ctx.form.destinationCity,
                active: true
              }, null, 8, ["originDistrict", "destinationDistrict"])
            ]),
            _: 1
          }, 8, ["modelValue", "currentIndex", "errors", "listKGs", "onSelectDistrict", "isErrorEmbargo", "isRebookingFlow", "isErrorRouteNotFound"]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Commodity, {
              ref: "commodity",
              id: "booking-commodity-section",
              modelValue: _ctx.form,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form = $event)),
              currentIndex: _ctx.currentIndex,
              "onUpdate:currentIndex": _cache[24] || (_cache[24] = ($event: any) => (_ctx.currentIndex = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[25] || (_cache[25] = ($event: any) => (_ctx.error = $event)),
              commodityIndex: 12
            }, null, 8, ["modelValue", "currentIndex", "error"]),
            _createVNode(_component_DeliveryService, {
              id: "booking-delivery-service-section",
              modelValue: _ctx.form.serviceType,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.serviceType = $event)),
              woodpacking: _ctx.form.woodpacking,
              "onUpdate:woodpacking": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.woodpacking = $event)),
              currentIndex: _ctx.currentIndex,
              "onUpdate:currentIndex": _cache[28] || (_cache[28] = ($event: any) => (_ctx.currentIndex = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[29] || (_cache[29] = ($event: any) => (_ctx.error = $event)),
              serviceTypeIndex: 13,
              originCityCode: _ctx.originCityCode,
              destination: _ctx.form.destinationCity,
              isLimited: _ctx.isLimited,
              isBlacklist: _ctx.isBlacklist,
              disabledCOD: _ctx.isCODDisabled,
              disabledDFOD: _ctx.isDFODDisabled,
              clientManagementDetail: _ctx.clientManagementDetail,
              formType: "client",
              isClient: ""
            }, null, 8, ["modelValue", "woodpacking", "currentIndex", "error", "originCityCode", "destination", "isLimited", "isBlacklist", "disabledCOD", "disabledDFOD", "clientManagementDetail"])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_DetailKoli, {
              ref: "detailKoli",
              destination: _ctx.form.destinationCity,
              form: _ctx.form,
              "onUpdate:form": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form = $event)),
              pieces: _ctx.form.pieces,
              "onUpdate:pieces": _cache[31] || (_cache[31] = ($event: any) => (_ctx.form.pieces = $event)),
              currentIndex: _ctx.currentIndex,
              "onUpdate:currentIndex": _cache[32] || (_cache[32] = ($event: any) => (_ctx.currentIndex = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[33] || (_cache[33] = ($event: any) => (_ctx.error = $event)),
              showWarningHwsProp: _ctx.showWarningHws,
              "onUpdate:showWarningHwsProp": _cache[34] || (_cache[34] = ($event: any) => (_ctx.showWarningHws = $event)),
              listCodActive: _ctx.ccoCodActive,
              listDfodActive: _ctx.ccoDfodActive,
              maxPieces: _ctx.maxPieces,
              isInterpackLanePending: _ctx.isInterpackLanePending,
              insuranceData: _ctx.insuranceData,
              hwsMinimumData: _ctx.heavyWeightSurchargeMinimumConfigData,
              goodsPriceIndex: 14,
              codAmountIndex: 15,
              insuranceIndex: 16,
              pieceIndex: 17,
              formType: "client",
              isRebookingFlow: _ctx.isRebookingFlow,
              schemaGoodsPriceType: 'client',
              insuranceBasic: _ctx.insuranceBasic,
              isRetail: false,
              isForceShowInsurance: true,
              isCrossCountryRoute: _ctx.isCrossCountryRoute
            }, null, 8, ["destination", "form", "pieces", "currentIndex", "error", "showWarningHwsProp", "listCodActive", "listDfodActive", "maxPieces", "isInterpackLanePending", "insuranceData", "hwsMinimumData", "isRebookingFlow", "insuranceBasic", "isCrossCountryRoute"]),
            _createVNode(_component_InsuranceBanner, {
              type: _ctx.insuranceType,
              "onUpdate:type": _cache[35] || (_cache[35] = ($event: any) => (_ctx.insuranceType = $event))
            }, null, 8, ["type"])
          ]),
          (_ctx.eligibleAdditionalInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode(_component_DocInternational, {
                  modelValue: _ctx.form.docInternationalForm,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.form.docInternationalForm = $event)),
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[37] || (_cache[37] = ($event: any) => (_ctx.currentIndex = $event)),
                  error: _ctx.errorDocInternational,
                  "onUpdate:error": _cache[38] || (_cache[38] = ($event: any) => (_ctx.errorDocInternational = $event)),
                  isFtz: false,
                  internationalDocumentDetailData: _ctx.internationalDocumentDetailData,
                  destinationCityId: _ctx.destinationCity.cityId,
                  originCityId: _ctx.districtDetail.cityId,
                  indexListCommodityCIPL: 18,
                  indexEmail: 19,
                  indexIdNumber: 20,
                  indexTaxNumber: 21,
                  indexShipmentStatus: 22,
                  indexImageIdUrl: 22,
                  indexImageTaxUrl: 23,
                  indexImageBeforePackingUrl: 24,
                  indexImageAfterPackingUrl: 25,
                  onFetchConfig: _ctx.getInternationalDocConfig,
                  clientCountry: _ctx.form.clientName.clientCountry
                }, null, 8, ["modelValue", "currentIndex", "error", "internationalDocumentDetailData", "destinationCityId", "originCityId", "onFetchConfig", "clientCountry"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isFtzAccount && _ctx.eligibleAdditionalInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.isFtzAccount)
            ? (_openBlock(), _createBlock(_component_DocInternational, {
                key: 3,
                ref: "ftz",
                modelValue: _ctx.form.ftzForm,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.form.ftzForm = $event)),
                currentIndex: _ctx.currentIndex,
                "onUpdate:currentIndex": _cache[40] || (_cache[40] = ($event: any) => (_ctx.currentIndex = $event)),
                error: _ctx.errorFtz,
                "onUpdate:error": _cache[41] || (_cache[41] = ($event: any) => (_ctx.errorFtz = $event)),
                isFtz: true,
                indexListCommodityCIPL: 26,
                indexEmail: 27,
                indexIdNumber: 28,
                indexTaxNumber: 29,
                indexShipmentStatus: 30,
                indexImageIdUrl: 31,
                indexImageTaxUrl: 32,
                indexImageBeforePackingUrl: 33,
                indexImageAfterPackingUrl: 34,
                clientCountry: _ctx.form.clientName.clientCountry
              }, null, 8, ["modelValue", "currentIndex", "error", "clientCountry"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_DeliveryType, {
              class: "flex-grow",
              currentIndex: _ctx.currentIndex,
              "onUpdate:currentIndex": _cache[42] || (_cache[42] = ($event: any) => (_ctx.currentIndex = $event)),
              modelValue: _ctx.form.productName,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.form.productName = $event)),
              isErrorUpselling: _ctx.isErrorUpselling,
              productIndex: 35,
              listProduct: _ctx.listProducts,
              isLoadingUpselling: _ctx.loadingUpsellingData,
              upsellingData: _ctx.upsellingData,
              onRetry: _ctx.getUpsellingData,
              formType: "client",
              isBookingRetail: false,
              clientData: _ctx.form.clientName
            }, null, 8, ["currentIndex", "modelValue", "isErrorUpselling", "listProduct", "isLoadingUpselling", "upsellingData", "onRetry", "clientData"]),
            (this.accountIsNonForeign)
              ? (_openBlock(), _createBlock(_component_InsuranceBanner, {
                  key: 0,
                  type: "shipment"
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_14
        ]),
        _createVNode("section", {
          class: 
          `sticky ${
            _ctx.isSidebarAndBreadcrumbV2 ? 'bottom-6' : 'bottom-3'
          } left-0 bg-white w-full flex z-10`
        
        }, [
          _createVNode(_component_Footer, {
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.form = $event)),
            class: "flex-grow",
            formType: "client",
            productType: "REGPACK",
            paymentMethod: _ctx.paymentMethod,
            "onUpdate:paymentMethod": _cache[45] || (_cache[45] = ($event: any) => (_ctx.paymentMethod = $event)),
            payload: _ctx.payload,
            destination: _ctx.form.destinationCity,
            estimationPrice: _ctx.estimationPriceData,
            totalPiece: _ctx.form.pieces.length,
            totalGrossWeight: _ctx.totalGrossWeight,
            totalDimensionWeight: _ctx.totalVolumeWeight,
            chargeableWeight: _ctx.formatWeight(_ctx.chargeableWeight),
            totalVolumeWeight: _ctx.totalVolumeWeight,
            isCampaign: false,
            goodsValue: _ctx.form.estimationPrice,
            isErrorEstimation: _ctx.errorEstimationPrice,
            isLoadingEstimation: _ctx.loadingEstimationPrice,
            isCodRetailApplied: 
            this.form.serviceType === 'cod' || this.form.serviceType === 'dfod'
          ,
            formCheckTariff: _ctx.payload,
            isValid: _ctx.isFormValid,
            isDisabled: !_ctx.isFormValid,
            idTariff: "id-tariff-booking-v3",
            isCrossCountryCod: _ctx.isCrossCountryCod,
            prefixCurrency: _ctx.prefixCurrency,
            onSubmit: _ctx.onBooking,
            clientData: _ctx.form.clientName
          }, null, 8, ["modelValue", "paymentMethod", "payload", "destination", "estimationPrice", "totalPiece", "totalGrossWeight", "totalDimensionWeight", "chargeableWeight", "totalVolumeWeight", "goodsValue", "isErrorEstimation", "isLoadingEstimation", "isCodRetailApplied", "formCheckTariff", "isValid", "isDisabled", "isCrossCountryCod", "prefixCurrency", "onSubmit", "clientData"])
        ], 2)
      ], 512)
    ], 512),
    _createVNode(_component_DialogPayment, {
      onSuccessPayment: _ctx.onCloseSuccess,
      billType: "booking",
      textHeader: "Pembuatan Booking Berhasil"
    }, null, 8, ["onSuccessPayment"]),
    (_ctx.isShowModalSuccessBooking)
      ? (_openBlock(), _createBlock(_component_ModalSuccessBooking, {
          key: 0,
          data: _ctx.modalSuccessBookingData,
          isCrossCountryCod: _ctx.isCrossCountryCod,
          prefixCurrency: _ctx.prefixCurrency,
          onClose: _ctx.onCloseSuccessBooking,
          onPrint: _ctx.printPDFOnSuccessBooking,
          formType: "client",
          clientCode: _ctx.form.clientName.clientCountry
        }, null, 8, ["data", "isCrossCountryCod", "prefixCurrency", "onClose", "onPrint", "clientCode"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalFailedBooking, _mergeProps({
      modelValue: _ctx.isShowModalFailedBooking,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.isShowModalFailedBooking = $event))
    }, _ctx.modalFailedBookingData, {
      onClose: _cache[47] || (_cache[47] = ($event: any) => (_ctx.isShowModalFailedBooking = false)),
      onReload: _cache[48] || (_cache[48] = ($event: any) => (
      _ctx.errorFailedBookingValidation
        ? (_ctx.isShowModalFailedBooking = false)
        : _ctx.onBooking(_ctx.bookingType)
    )),
      onScrollToDestination: _cache[49] || (_cache[49] = ($event: any) => (_ctx.scrollToPosition('booking-receiver-section'))),
      onScrollToCod: _cache[50] || (_cache[50] = ($event: any) => (_ctx.scrollToPosition('booking-delivery-service-section'))),
      onScrollToCommodity: _cache[51] || (_cache[51] = ($event: any) => (_ctx.scrollToPosition('booking-commodity-section')))
    }), null, 16, ["modelValue"]),
    _createVNode(_component_ModalPreviewInvoice),
    (_ctx.isSuccessCreateInvoice)
      ? (_openBlock(), _createBlock(_component_ModalSuccessReceipt, {
          key: 1,
          visible: _ctx.isSuccessCreateInvoice,
          "onUpdate:visible": _cache[52] || (_cache[52] = ($event: any) => (_ctx.isSuccessCreateInvoice = $event)),
          mode: "create",
          invoiceData: _ctx.successCreateInvoiceData,
          onClose: _ctx.onCloseSuccessCreateInvoice,
          onDownload: _ctx.handleDownloadCreateInvoice
        }, null, 8, ["visible", "invoiceData", "onClose", "onDownload"]))
      : _createCommentVNode("", true),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"])
  ], 64))
}